<template>
    <section id="companion-ad-container">
        <adsense
                adtest="on"
                ad-client="ca-pub-4242311851434474"
                :ad-slot="adSlot"
                ad-style="display: block"
                ad-format="auto">
        </adsense>
    </section>
</template>


<script>
    import AdSense from './AdSense.vue';

    export default {
        name: 'CompanionAdContainer',
        props: ['adSlot'],

        data(){
            return {}
        },

        components: {
            'adsense': AdSense
        }
    }
</script>


// WEBPACK FOOTER //
// AdContainer.vue?785fcddc